export default [
  // AI 助手独立全屏，不套 MobileLayout，因此不显示底部导航
  {
    path: '/mobile/ai',
    name: 'MobileAI',
    component: () => import('@/mobile/ai/Chat.vue'),
    meta: { title: 'AI助手', hideInMenu: true, requiresAuth: true }
  },
  {
    path: '/mobile',
    component: () => import('@/mobile/layout/MobileLayout.vue'),
    meta: { title: '移动端', hideInMenu: true, requiresAuth: true },
    children: [
      {
        path: 'orders/list',
        name: 'OrderList',
        component: () => import('@/mobile/order/List.vue'),
        meta: { title: '订单列表', permission: 'shipping:view' }
      },
      {
        path: 'orders/create',
        name: 'OrderCreate',
        component: () => import('@/mobile/order/Create.vue'),
        meta: { title: '新建订单', permission: 'shipping:manage' }
      },
      {
        path: 'orders',
        name: 'OrderDashboard',
        component: () => import('@/mobile/order/Dashboard.vue'),
        meta: { title: '工作流' }
      },
      // 采购单（订单管理）
      {
        path: 'purchase-orders',
        name: 'MobilePurchaseOrderList',
        component: () => import('@/mobile/purchaseOrder/List.vue'),
        meta: { title: '采购单管理' }
      },
      {
        path: 'purchase-orders/create',
        name: 'MobilePurchaseOrderCreate',
        component: () => import('@/mobile/purchaseOrder/Create.vue'),
        meta: { title: '新建采购单' }
      },
      {
        path: 'purchase-orders/:id',
        name: 'MobilePurchaseOrderDetail',
        component: () => import('@/mobile/purchaseOrder/Detail.vue'),
        meta: { title: '采购单详情' }
      },
      {
        path: 'purchase-orders/:id/edit',
        name: 'MobilePurchaseOrderEdit',
        component: () => import('@/mobile/purchaseOrder/Edit.vue'),
        meta: { title: '编辑采购单' }
      },
      {
        path: 'orders/list/:id',
        name: 'OrderDetail',
        component: () => import('@/mobile/order/Detail.vue'),
        meta: { title: '订单详情' }
      },
      {
        path: 'purchases',
        name: 'PurchaseList',
        component: () => import('@/mobile/purchase/List.vue'),
        meta: { title: '采购申请', permission: 'purchase:view' }
      },
      {
        path: 'purchases/create',
        name: 'PurchaseCreate',
        component: () => import('@/mobile/purchase/Create.vue'),
        meta: { title: '新建采购申请', permission: 'purchase:manage' }
      },
      {
        path: 'purchases/:id',
        name: 'PurchaseDetail',
        component: () => import('@/mobile/purchase/Detail.vue'),
        meta: { title: '采购订单详情', permission: 'purchase:view' }
      },
      {
        path: 'shippings',
        name: 'ShippingList',
        component: () => import('@/mobile/shipping/List.vue'),
        meta: { title: '发货管理', permission: 'shipping:view' }
      },
      {
        path: 'shippings/create',
        name: 'ShippingCreate',
        component: () => import('@/mobile/shipping/Create.vue'),
        meta: { title: '新建发货单', permission: 'shipping:manage' }
      },
      // 维修业务
      {
        path: 'repairs/requests',
        name: 'MobileRepairRequests',
        component: () => import('@/mobile/repair/Requests.vue'),
        meta: { title: '维修申请' }
      },
      {
        path: 'repairs/reports',
        name: 'MobileRepairReports',
        component: () => import('@/mobile/repair/Reports.vue'),
        meta: { title: '维修报告' }
      },
      // 审批
      {
        path: 'approvals/purchase-requests',
        name: 'MobileApprovalsPurchaseRequests',
        component: () => import('@/mobile/approvals/PurchaseRequests.vue'),
        meta: { title: '采购申请审批' }
      },
      {
        path: 'approvals/purchase-orders',
        name: 'MobileApprovalsPurchaseOrders',
        component: () => import('@/mobile/approvals/PurchaseOrders.vue'),
        meta: { title: '订单审批' }
      },
      {
        path: 'approvals/shippings',
        name: 'MobileApprovalsShippings',
        component: () => import('@/mobile/approvals/Shippings.vue'),
        meta: { title: '发货审批' }
      },
      // 审批-通用三菜单
      {
        path: 'approvals/my',
        name: 'MobileMyApplications',
        component: () => import('@/mobile/approvals/My.vue'),
        meta: { title: '我的申请' }
      },
      {
        path: 'approvals/todo',
        name: 'MobilePendingApprovals',
        component: () => import('@/mobile/approvals/Todo.vue'),
        meta: { title: '待审批' }
      },
      {
        path: 'approvals/history',
        name: 'MobileApprovalHistory',
        component: () => import('@/mobile/approvals/History.vue'),
        meta: { title: '审批历史' }
      },
      {
        path: 'shippings/:id',
        name: 'ShippingDetail',
        component: () => import('@/mobile/shipping/Detail.vue'),
        meta: { title: '发货单详情' }
      },
      {
        path: 'shippings/:id/edit',
        name: 'ShippingEdit',
        component: () => import('@/mobile/shipping/Edit.vue'),
        meta: { title: '编辑发货单', permission: 'shipping:manage' }
      },
      {
        path: 'profile',
        name: 'MobileProfile',
        component: () => import('@/mobile/profile/Index.vue'),
        meta: { title: '我的' }
      },
      {
        path: 'profile/password',
        name: 'MobileChangePassword',
        component: () => import('@/mobile/profile/ChangePassword.vue'),
        meta: { title: '修改密码' }
      },
      {
        path: 'profile/phone',
        name: 'MobileBindPhone',
        component: () => import('@/mobile/profile/BindPhone.vue'),
        meta: { title: '绑定手机' }
      },
      {
        path: 'profile/email',
        name: 'MobileBindEmail',
        component: () => import('@/mobile/profile/BindEmail.vue'),
        meta: { title: '绑定邮箱' }
      },
      {
        path: 'profile/wechat',
        name: 'MobileBindWechat',
        component: () => import('@/mobile/profile/BindWechat.vue'),
        meta: { title: '绑定微信' }
      }
    ]
  }
] 